import { useState, useEffect } from 'react';
import ClanWarBattle from './clanwarsBattlePage';

const ClanWarsPage = ({ clanId, userId, setCurrentPage, triggerToast}) => {
  const [clanData, setClanData] = useState(null);
  const [war, setWar] = useState(null);
  const [warError, setWarError] = useState('');
  const [registering, setRegistering] = useState(false);
  useEffect(() => {
    let active = true;
    const refresh = async () => { try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}/wars/status`);
      const data = await response.json();
      if (!response.ok) throw new Error(data.error);
      if (active) { setWar(data); setWarError(''); }
    } catch (error) { if (active) setWarError(error.message); } };
    refresh(); const timer = setInterval(refresh, 5000);
    return () => { active = false; clearInterval(timer); };
  }, [clanId]);
  const [isLeader, setIsLeader] = useState(false);
  const [nextWarTime, setNextWarTime] = useState(null);
  const [remainingTime, setRemainingTime] = useState('');

  // Загружаем данные о клане и статус пользователя
  useEffect(() => {
    const fetchClanData = async () => {
      try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}/clans/${clanId}`);
        if (!response.ok) throw new Error('Ошибка загрузки данных о клане');
        const data = await response.json();
        setClanData(data);

        // Проверяем роль пользователя
        const member = data.members.find((member) => Number(member.id || member.user_id) === Number(userId));
        if (member) setIsLeader(member.clan_role === 'leader');
      } catch (error) {
        console.error('Ошибка загрузки данных о клане:', error);
        setClanData(null);
      }
    };
    if (clanId) fetchClanData();
  }, [clanId, userId]);

  useEffect(() => {
    const calculateNextWarTime = () => {
      const now = new Date();
      const nextSaturday = new Date(now);
      nextSaturday.setUTCDate(now.getUTCDate() + ((6 - now.getUTCDay() + 7) % 7));
      nextSaturday.setUTCHours(11, 0, 0, 0); // 14:00 MSK
      if (nextSaturday <= now) nextSaturday.setUTCDate(nextSaturday.getUTCDate() + 7);

      setNextWarTime(nextSaturday);
    };

    calculateNextWarTime();
  }, []);


  useEffect(() => {
    if (!nextWarTime) return;
  
    const timer = setInterval(() => {
      const now = new Date();
      const diff = nextWarTime - now;
  
      if (diff <= 0) {
        clearInterval(timer);
        setRemainingTime('Время кланвара!');
        return;
      }
  
      // Вычисление оставшихся дней, часов, минут и секунд
      const days = Math.floor(diff / (1000 * 60 * 60 * 24));
      const hours = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((diff % (1000 * 60)) / 1000);
  
      const formattedTime = days > 0
        ? `${days}д ${hours}ч ${minutes}м ${seconds}с`
        : `${hours}ч ${minutes}м ${seconds}с`;
  
      setRemainingTime(formattedTime);
    }, 1000);
  
    return () => clearInterval(timer);
  }, [nextWarTime]);

  // Функция регистрации клана
  const handleRegisterForWar = async () => {
    if (registering) return;
    setRegistering(true);
    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}/wars/register`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ clanId }),
      });

      const data = await response.json().catch(() => ({}));
      if (response.ok) {
        setWar(current => ({ ...current, registered: true }));
        triggerToast(data.message || 'Клан успешно зарегистрирован на кланвар!');
      } else {
        triggerToast(data.error || 'Ошибка регистрации клана на кланвар.');
      }
    } catch (error) {
      console.error('Ошибка регистрации клана на кланвар:', error);
      triggerToast('Не удалось зарегистрировать клан. Попробуйте снова.');
    } finally { setRegistering(false); }
  };

  if (!clanData) {
    return <p>Загрузка данных о клане...</p>;
  }

  const { members } = clanData; // Список участников клана
  const members_count = members.length; // Количество участников клана

  return (
    <div className="container_ war-page">
      <span className="eyebrow">КЛАН ПРОТИВ КЛАНА</span>
      <h1 className="clanwars-title">Клановые войны</h1>
      <p className="war-timer">
        Следующий кланвар начнётся через: <strong>{remainingTime}</strong>
      </p>
      <button onClick={() => setCurrentPage('clans_info')} className="back-button">
        Назад к клану
      </button>

      {warError && <p role="status">{warError}</p>}
      {war?.match && <ClanWarBattle key={war.match.id} match={war.match} clanId={clanId} />}
      <section className="war-rules"><h2>Пять минут. Одна команда.</h2><p>Наберите больше ударов, чем соперник, и пройдите в следующий раунд. Турнир начинается при наличии двух зарегистрированных кланов.</p><small>При равном счёте проходит клан с меньшим ID. Непарный участник проходит автоматически.</small></section>
      {war?.registered ? <p className="status-pill">✓ Вы зарегистрированы на следующую войну</p> : isLeader ? (
  <>
    {members_count >= 20 ? (
      <button disabled={registering} onClick={handleRegisterForWar} className="register-button">
        Зарегистрировать клан на кланвар
      </button>
    ) : (
      <p className="registration-warning">
        Для регистрации клана нужно набрать 20 участников клана. Текущий состав: {members_count}!
      </p>
    )}
  </>
) : <p>Зарегистрировать команду может лидер клана. Состав: {members_count}/20.</p>}

    </div>
  );
};

export default ClanWarsPage;
